import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../../app.config';

@Injectable()
export class CompetencyService {
  constructor (private http: HttpClient , private api: AppConfig) {
  }

  addCompetency (data) {
    return this.http.post(this.api.baseUrl + '/competency/addCompetency' , data , this.api.jsonTokenHeaders);
  }

  getCompetenciesWithSkills (search = '') {
    return this.http.get(this.api.baseUrl + '/competency/competenciesWithSkills?search=' + search, this.api.jsonTokenHeaders);
  }

  competenciesByOrganization (id) {
    return this.http.get(this.api.baseUrl + '/competency/competenciesByOrganization?id=' + id, this.api.jsonTokenHeaders);
  }

  getCompetencies () {
    return this.http.get(this.api.baseUrl + '/competency/competencies', this.api.jsonTokenHeaders);
  }

  deleteCompetency (id) {
    return this.http.delete(this.api.baseUrl + '/competency/deleteCompetency?id=' + id , this.api.jsonTokenHeaders);
  }

  addSkill (data) {
    return this.http.post(this.api.baseUrl + '/skill/addSkill' , data , this.api.jsonTokenHeaders);
  }

  deleteSkill (id) {
    return this.http.delete(this.api.baseUrl + '/skill/deleteSkill?id=' + id , this.api.jsonTokenHeaders);
  }

  updateCompetenciesOrder(orderData: {id: number, orderId: number}[]) {
    return this.http.post(this.api.baseUrl + '/competency/updateOrder', { orders: orderData }, this.api.jsonTokenHeaders);
  }
}
